export default "__VITE_ASSET__CkB4T$Mr__"